import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function DemoBanner() {
  const [dismissed, setDismissed] = useState(false);
  const {
    lang
  } = useLang();
  if (dismissed) return null;
  const ua = lang === 'ua';
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-black text-white border-t border-neutral-800 shadow-2xl" data-id="element-56">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-4 md:py-5" data-id="element-57">
        {/* MOBILE layout */}
        <div className="flex flex-col items-center text-center gap-3 md:hidden" data-id="element-58">
          {/* Close */}
          <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 p-1 text-neutral-500 hover:text-white transition-colors" aria-label="Закрити" data-id="element-59">
            <X className="h-4 w-4" data-id="element-60" />
          </button>

          {/* Icon */}
          <span style={{
          fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif',
          fontSize: '28px',
          lineHeight: 1
        }} data-id="element-61">
            🖥️
          </span>

          {/* Title */}
          <p className="font-bold text-sm text-white leading-snug" data-id="element-62">
            {ua ? 'Це демонстраційний сайт' : 'Это демонстрационный сайт'}
          </p>

          {/* Description */}
          <p className="text-neutral-400 text-xs leading-relaxed max-w-xs" data-id="element-63">
            {ua ? <>
                Адаптуємо під ваш бізнес або зробимо з нуля. Вартість:{' '}
                <span className="text-white font-semibold whitespace-nowrap" data-id="element-64">
                  9&nbsp;000&nbsp;грн
                </span>{' '}
                <span className="line-through text-neutral-600 whitespace-nowrap" data-id="element-65">
                  15&nbsp;000&nbsp;грн
                </span>
              </> : <>
                Адаптируем под ваш бизнес или сделаем с нуля. Стоимость:{' '}
                <span className="text-white font-semibold whitespace-nowrap" data-id="element-66">
                  9&nbsp;000&nbsp;грн
                </span>{' '}
                <span className="line-through text-neutral-600 whitespace-nowrap" data-id="element-67">
                  15&nbsp;000&nbsp;грн
                </span>
              </>}
          </p>

          {/* Buttons */}
          <div className="flex flex-col w-full gap-2 max-w-xs" data-id="element-68">
            <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-white text-black text-xs font-bold px-4 py-2.5 hover:bg-neutral-100 transition-colors" data-id="element-69">
              {ua ? 'Замовити сайт' : 'Заказать сайт'}
            </a>
            <a href="https://t.me/jetly_agency" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-1.5 border border-neutral-600 text-white text-xs font-medium px-4 py-2.5 hover:border-white transition-colors" data-id="element-70">
              <svg className="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-71">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z" data-id="element-72" />
              </svg>
              Telegram
            </a>
          </div>
        </div>

        {/* DESKTOP / TABLET layout */}
        <div className="hidden md:flex items-center gap-4 lg:gap-8" data-id="element-73">
          {/* Icon */}
          <span className="flex-shrink-0" style={{
          fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif',
          fontSize: '28px',
          lineHeight: 1
        }} data-id="element-74">
            🖥️
          </span>

          {/* Text block */}
          <div className="flex-1 min-w-0" data-id="element-75">
            <p className="font-bold text-sm lg:text-base text-white mb-0.5" data-id="element-76">
              {ua ? 'Це демонстраційний сайт' : 'Это демонстрационный сайт'}
            </p>
            <p className="text-neutral-400 text-xs lg:text-sm leading-snug" data-id="element-77">
              {ua ? <>
                  Адаптуємо під ваш бізнес або зробимо з нуля. Вартість:{' '}
                  <span className="text-white font-semibold whitespace-nowrap" data-id="element-78">
                    9&nbsp;000&nbsp;грн
                  </span>{' '}
                  <span className="line-through text-neutral-600 whitespace-nowrap" data-id="element-79">
                    15&nbsp;000&nbsp;грн
                  </span>
                </> : <>
                  Адаптируем под ваш бизнес или сделаем с нуля. Стоимость:{' '}
                  <span className="text-white font-semibold whitespace-nowrap" data-id="element-80">
                    9&nbsp;000&nbsp;грн
                  </span>{' '}
                  <span className="line-through text-neutral-600 whitespace-nowrap" data-id="element-81">
                    15&nbsp;000&nbsp;грн
                  </span>
                </>}
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-82">
            <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-white text-black text-xs lg:text-sm font-bold px-4 py-2 hover:bg-neutral-100 transition-colors whitespace-nowrap" data-id="element-83">
              {ua ? 'Замовити сайт' : 'Заказать сайт'}
            </a>
            <a href="https://t.me/jetly_agency" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-1.5 border border-neutral-600 text-white text-xs lg:text-sm font-medium px-4 py-2 hover:border-white transition-colors whitespace-nowrap" data-id="element-84">
              <svg className="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-85">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z" data-id="element-86" />
              </svg>
              Telegram
            </a>
          </div>

          {/* Close */}
          <button onClick={() => setDismissed(true)} className="flex-shrink-0 p-1 text-neutral-500 hover:text-white transition-colors" aria-label="Закрити" data-id="element-87">
            <X className="h-4 w-4" data-id="element-88" />
          </button>
        </div>
      </div>
    </div>;
}